import { useState } from "react";
import CardContainer from "../../features/cards/Cards";
import Proveedores from "../../assets/img/svg/proveedores.svg";
import Proyectos from "../../assets/img/svg/proyectos.svg";
import Soporte from "../../assets/img/svg/soporte.svg";
import Seguridad from "../../assets/img/svg/seguridad.svg";
import Usuarios from "../../assets/img/svg/usuario.svg";
import Personalizar from "../../assets/img/svg/personalizar.svg";
import axios from "axios";
import "./Home.responsive.css";

const Home = ({ API_URL, user }) => {
  const fixedArray = ["1", "2", "3", "4", "5"];
  const receivedText = user.vistas; // Texto plano recibido
  const receivedArray = receivedText.split(","); // Convertir a array

  const [isCustomizing, setIsCustomizing] = useState(false); // Mostrar u ocultar personalización
  const [selectedCards, setSelectedCards] = useState(receivedArray); // Cards seleccionadas

  // Datos de las cards
  const cardData = {
    1: {
      icon: Usuarios,
      title: "Usuarios",
      description:
        "Administra y organiza los perfiles de los usuarios de forma centralizada.",
      url: "/usuarios",
      size: 35,
    },
    2: {
      icon: Proveedores,
      title: "Proveedores",
      description:
        "Gestiona la información de tus proveedores de manera ágil y organizada.",
      url: "/proveedores",
      size: 35,
    },
    3: {
      icon: Proyectos,
      title: "Proyectos",
      description:
        "Supervisa y administra cada detalle de tus proyectos, desde el inicio hasta la entrega.",
      url: "/proyectos",
      size: 35,
    },
    4: {
      icon: Soporte,
      title: "Soporte Operativo",
      description: "Accede a manuales y soporte técnico cuando lo necesites.",
      url: "/",
      size: 35,
    },
    5: {
      icon: Seguridad,
      title: "Seguridad",
      description:
        "Gestiona las inspecciones y complimientos de normativas en HSEQ en cada proyecto.",
      url: "/",
      size: 35,
    },
  };

  // Manejar toggle de una opción en personalización
  const handleToggleOption = (cardId) => {
    setSelectedCards(
      (prev) =>
        prev.includes(cardId)
          ? prev.filter((id) => id !== cardId) // Quitar si ya está seleccionado
          : [...prev, cardId] // Agregar si no está seleccionado
    );
  };

  // Manejar guardado
  const handleSave = async () => {
    const sortedArray = [...selectedCards].sort((a, b) => a - b); // Ordenar
    let payload = sortedArray.join(","); // Convertir a texto plano

    try {
      const response = await axios({
        method: "put",
        url: `${API_URL}/api/usuarios-vistas?id=${user.id}`,
        data: payload, // Enviar el payload limpio
        headers: {
          "Content-Type": "text/plain",
        },
        transformRequest: [(data) => data], // Evitar transformaciones automáticas
        withCredentials: true, // Incluir credenciales de sesión
      });

      setIsCustomizing(false); // Cerrar personalización
    } catch (error) {
      console.error("Error updating vistas:", error);
    }
  };

  return (
    <div className="HomeContainer">
      <div>
        <h1>¡Hola! {user.nombre}</h1>
        <p>Selecciona el campo al que deseas ingresar</p>
      </div>

      {/* Vista normal: solo las cards seleccionadas */}
      <div className="CardGrid">
        {selectedCards.map((key) => {
          if (key === "1" && !user?.perfil?.esAdministrador) return null;
          if (key === "4" && !user?.perfil?.esAdministrador) return null;
          if (key === "5" && !user?.perfil?.esAdministrador) return null;
          return (
            <CardContainer
              key={key}
              width="clamp(16rem, 45vw, 22rem)"
              height="clamp(13rem, 26vw, 14rem)"
              icon={
                <img
                  src={cardData[key].icon}
                  alt={cardData[key].title}
                  style={{
                    width: `${cardData[key].size}px`,
                    height: `${cardData[key].size}px`,
                    objectFit: "contain",
                  }}
                />
              }
              title={cardData[key].title}
              description={cardData[key].description}
              url={cardData[key].url}
            />
          );
        })}
      </div>

      {/* Botón para personalizar */}
      <div className="PersonalizationContainer">
        <button
          onClick={() => setIsCustomizing(!isCustomizing)}
          style={{
            marginTop: "1rem",
            padding: "0.5rem 1rem",
            width: "100%",
            backgroundColor: "#223D51",
            color: "white",
            border: "none",
            borderRadius: "5px",
            fontFamily: "Nunito",
            fontWeight: "700",
            fontSize: "14px",
          }}
        >
          <img src={Personalizar} alt={""} /> Personalizar vista
        </button>

        {/* Menú de personalización */}
        {isCustomizing && (
          <div className="CustomizationMenu">
            <div className="OptionList">
              {fixedArray.map((key) => {
                if (key === "1" && !user.perfil.esAdministrador) return null;
                if (key === "3" && !user.perfil.esAdministrador) return null;
                if (key === "4" && !user.perfil.esAdministrador) return null;
                return (
                  <div key={key} className="OptionItem">
                    <span>
                      <img src={cardData[key].icon} alt={cardData[key].title} />
                      {cardData[key].title}
                    </span>
                    <div
                      className={`toggle ${
                        selectedCards.includes(key) ? "active" : ""
                      }`}
                      onClick={() => handleToggleOption(key)}
                    >
                      <div className="toggle-knob"></div>
                    </div>
                  </div>
                );
              })}
            </div>
            <button
              onClick={handleSave}
              style={{
                marginTop: "1rem",
                padding: "0.5rem 1rem",
                width: "100%",
                backgroundColor: "#223D51",
                color: "white",
                border: "none",
                borderRadius: "5px",
                fontFamily: "Nunito",
                fontWeight: "700",
                fontSize: "14px",
              }}
            >
              Guardar
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Home;
